(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ritual-kit-audio-preview"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rk-audio-preview]').forEach((preview) => {
        if (preview.dataset.rkAudioInitialized) return;
        preview.dataset.rkAudioInitialized = 'true';
        const audio = preview.querySelector('[data-rk-audio-player]');
        const toggle = preview.querySelector('[data-rk-audio-toggle]');
        const label = preview.querySelector('[data-rk-audio-label]');
        const icon = preview.querySelector('[data-rk-audio-icon]');
        const error = preview.querySelector('[data-rk-audio-error]');
        const sync = () => {
          const playing = !audio.paused && !audio.ended;
          label.textContent = playing ? 'Pause preview' : 'Preview (30 sec)';
          icon.textContent = playing ? 'Ⅱ' : '▶';
        };
        toggle.addEventListener('click', async () => {
          error.hidden = true;
          audio.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          if (!audio.paused) {
            audio.pause();
            return;
          }
          if (audio.ended) audio.currentTime = 0;
          try {
            await audio.play();
          } catch (_) {
            error.hidden = false;
            sync();
          }
        });
        audio.addEventListener('play', () => {
          document.querySelectorAll('[data-rk-audio-player]').forEach((other) => {
            if (other !== audio) other.pause();
          });
          sync();
        });
        audio.addEventListener('pause', sync);
        audio.addEventListener('ended', sync);
        audio.addEventListener('error', () => { error.hidden = false; sync(); });
      });
  } catch(e) { console.error(e); }
})();

})();
